import React from 'react'
import NextImage from 'next/image'
import { Text, TextBlock } from '@/components/common'
import ApplyButton from '../ApplyButton'
import { ContentBlock } from '../types'

export interface Props extends ContentBlock {
  formUrl: string
  className?: string
}

const Funding: React.FC<Props> = ({
  image,
  title,
  text,
  formUrl,
  className,
}) => {
  return (
    <div className={className}>
      <div className="mx-auto max-w-[1536px] px-4 md:px-8">
        <div className="flex flex-col overflow-hidden rounded-lg md:flex-row">
          <div className="flex w-full items-center justify-center bg-[#af7d62] py-6 sm:py-8 md:w-2/5">
            <div className="w-4/5">
              <NextImage
                alt={image?.description || ''}
                src={`https:${image?.file.url}`}
                width={image?.file.details.image.width}
                height={image?.file.details.image.height}
                loading="lazy"
              />
            </div>
          </div>

          <div className="relative flex w-full flex-col justify-center bg-black p-8 text-white sm:p-12 md:w-3/5 md:p-16 lg:p-24">
            <div className="pointer-events-none absolute inset-0 hidden items-center pl-8 opacity-10 md:flex lg:pl-16 xl:pl-20">
              <div className="relative text-[7rem] font-bold uppercase leading-none lg:text-[8rem] xl:text-[10rem]">
                {title}
              </div>
            </div>

            <div className="relative z-10">
              <Text as="h2" preset="heading.lg" className="mb-6">
                {title}
              </Text>

              <div className="max-w-sm">
                <TextBlock document={text} />
              </div>

              <ApplyButton url={formUrl} variant="hollow" className="mt-6" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Funding
